var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9939 8.5L8.66056 10.1667L11.9939 6.83333M16.9939 8.5C16.9939 9.48491 16.7999 10.4602 16.423 11.3701C16.0461 12.2801 15.4936 13.1069 14.7972 13.8033C14.1008 14.4997 13.274 15.0522 12.364 15.4291C11.4541 15.806 10.4788 16 9.4939 16C8.50898 16 7.53371 15.806 6.62377 15.4291C5.71383 15.0522 4.88703 14.4997 4.1906 13.8033C3.49416 13.1069 2.94171 12.2801 2.5648 11.3701C2.18789 10.4602 1.9939 9.48491 1.9939 8.5C1.9939 6.51088 2.78407 4.60322 4.1906 3.1967C5.59712 1.79018 7.50477 1 9.4939 1C11.483 1 13.3907 1.79018 14.7972 3.1967C16.2037 4.60322 16.9939 6.51088 16.9939 8.5Z",
    stroke: "#0369A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.3e6847157acf7b0f9f8fc364e868bab8.svg";
export { ForwardRef as ReactComponent };